export default "__VITE_ASSET__Qm_EuVqi__"